exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3_IIx3qL7PLWV0{padding:0;text-align:center;background-color:#faf3c0;border-bottom:1px solid #e6c60d}.y713MCtKnRL7Xv{line-height:32px;margin:0;font-weight:700}.y713MCtKnRL7Xv a{color:#5e6c84;margin-left:8px}", ""]);

// exports
exports.locals = {
	"banner": "_3_IIx3qL7PLWV0",
	"text": "y713MCtKnRL7Xv"
};